var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLinkExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 158,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M75 158c41.421 0 75-33.579 75-75S116.421 8 75 8 0 41.579 0 83s33.579 75 75 75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M83 79H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6ZM83 106H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M130.363 52.929v64.81c0 2.581-2.15 4.581-4.549 4.581h-99.23c-2.553 0-4.565-2.097-4.565-4.581v-64.81L73.04 8.688a4.576 4.576 0 0 1 5.978-.017l51.348 44.258h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.512 21.137v88.98a3.423 3.423 0 0 1-3.424 3.424H29.296a3.423 3.423 0 0 1-3.424-3.424v-88.98a4.792 4.792 0 0 1 4.792-4.793h91.058a4.792 4.792 0 0 1 4.792 4.793h-.002Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M99 55.22c-.216.813-.336 1.663-.663 2.43-1.482 3.478-4.099 5.659-7.958 6.23-3.33.491-6.195-.53-8.58-2.83-1.872-1.807-3.728-3.63-5.59-5.447-.621-.608-.624-1.045-.012-1.645a1096.12 1096.12 0 0 1 3.236-3.16c.543-.53.85-.527 1.4.005.638.618 1.273 1.237 1.905 1.858.53.52.526.838-.015 1.367-.242.237-.492.466-.757.717.1.116.168.207.249.286.982.96 1.96 1.927 2.953 2.878 1.481 1.416 3.255 1.895 5.238 1.34 1.993-.56 3.27-1.888 3.777-3.852.415-1.614.106-3.153-1.027-4.384-1.144-1.246-2.459-2.343-3.739-3.543.102-.03.086-.03.076-.021-.67.558-1.32.53-1.95-.086-.561-.547-1.127-1.09-1.682-1.643-.424-.423-.431-.756-.009-1.173.967-.957 1.94-1.907 2.922-2.849.515-.494 1.009-.488 1.525.011 1.941 1.884 3.889 3.762 5.812 5.665 1.58 1.564 2.54 3.438 2.808 5.632.008.069.053.133.082.199v2.015H99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M53 43.218c.21-.783.335-1.6.645-2.343 1.534-3.687 4.33-5.91 8.41-6.215 3.037-.228 6.103-.09 9.157-.094.636 0 .996.379 1 1.004.013 1.592.01 3.182 0 4.774-.002.532-.256.785-.799.793-1.017.016-2.036.015-3.054 0-.569-.008-.793-.257-.8-.827-.004-.379 0-.757 0-1.116-.05-.037-.073-.07-.096-.07-1.69.01-3.388-.064-5.07.057-2.297.165-4.089 1.792-4.607 3.982-.623 2.633.883 5.285 3.508 6.121a5.495 5.495 0 0 0 1.537.25c1.554.03 3.11.01 4.73.01 0-.205-.007-.39 0-.572.02-.48.268-.745.747-.751 1.047-.012 2.096-.012 3.144 0 .48.005.758.268.761.74.013 1.4.018 2.802 0 4.204-.01.651-.395.942-1.183.943-2.635.004-5.27.016-7.906-.008-.743-.007-1.499-.062-2.227-.206-4.124-.824-7.26-4.138-7.807-8.198-.014-.098-.06-.192-.09-.288v-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA8E05",
    d: "M85.654 30.087c-.074.234-.114.486-.227.7a400.395 400.395 0 0 1-2.732 5.069c-.339.615-.994.931-1.595.84-.714-.109-1.25-.535-1.352-1.215a1.895 1.895 0 0 1 .167-1.09 216.325 216.325 0 0 1 2.662-4.958c.403-.735 1.097-1.041 1.828-.857.727.183 1.207.78 1.25 1.51h-.001ZM74.26 27c.721-.004 1.297.378 1.539 1.114.599 1.827 1.18 3.66 1.74 5.497a1.499 1.499 0 0 1-.933 1.851c-.807.297-1.703-.016-2.008-.814-.445-1.17-.798-2.373-1.183-3.565-.233-.721-.472-1.44-.668-2.17-.264-.983.482-1.906 1.514-1.913ZM92.558 37.124c-.007.67-.393 1.226-1.093 1.446a264.27 264.27 0 0 1-5.642 1.714c-.892.259-1.736-.213-1.994-1.036-.25-.8.175-1.627 1.052-1.905 1.859-.589 3.725-1.16 5.6-1.7 1.087-.313 2.088.43 2.077 1.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.316 51.984c-.383.001-.755-.123-1.061-.352l-.019-.014-3.995-3.056a1.777 1.777 0 0 1 .847-3.17 1.773 1.773 0 0 1 1.313.351l2.588 1.985 6.115-7.978a1.774 1.774 0 0 1 2.488-.329l-.037.053.039-.052a1.777 1.777 0 0 1 .328 2.489L75.73 51.29a1.775 1.775 0 0 1-1.413.692l-.001.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m130.363 52.929-.048 65.374a4.436 4.436 0 0 1-1.489 2.84c-.047.046-.095.078-.142.125L76.192 87.695l5.46-3.5 48.713-31.266h-.002ZM76.191 87.695l-52.493 33.589c-.74-.557-1.496-1.713-1.632-2.981l-.047-65.374L70.512 84.07l5.68 3.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M128.825 121.141v.005c-1.45 1.283-2.888 1.14-3.043 1.172l-99.764-.046c-.964-.104-1.893-.531-2.666-1.302l47.16-36.899 3.275-2.563a3.597 3.597 0 0 1 4.431 0l3.433 2.688 47.176 36.947-.002-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.384 0H145v122.318H7.384z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53 27h46v37H53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 75,
    x2: 75,
    y1: 8,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLinkExpired);
export default __webpack_public_path__ + "static/media/email-link-expired.0a4d0a28004de80d6050157a01bcb4c7.svg";
export { ForwardRef as ReactComponent };